import React from 'react';

const WindowIcon = () => {
  return (
    <svg
      width='234'
      height='169'
      viewBox='0 0 234 169'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 10.8204V27.3424V158.958C0 164.898 4.87457 169.8 10.7772 169.8H222.972C228.872 169.8 233.747 164.898 233.747 158.958V27.3424V11.3388C233.747 4.90267 228.615 0 222.458 0H10.7772L0 10.8204Z'
        fill='url(#paint0_linear_14815_87917)'
      />
      <path
        d='M106.494 86.237L64.6726 85.9781C62.8757 85.9781 61.5928 84.4232 61.5928 82.8681C61.5928 81.0755 63.1327 79.7793 64.6726 79.7793L106.494 80.0387C108.291 80.0387 109.574 81.572 109.574 83.127C109.574 84.6821 108.291 86.237 106.494 86.237Z'
        fill='#D6DCE8'
      />
      <path
        d='M205.794 86.237L157.555 85.9781C155.76 85.9781 154.478 84.4232 154.478 82.8681C154.478 81.0755 156.015 79.7793 157.555 79.7793L205.537 80.0387C207.333 80.0387 208.616 81.572 208.616 83.127C208.873 84.6821 207.588 86.237 205.794 86.237Z'
        fill='#EAECF3'
      />
      <path
        d='M173.721 146.883L125.483 146.625C123.686 146.625 122.403 145.069 122.403 143.514C122.403 141.721 123.943 140.426 125.483 140.426L173.721 140.685C175.516 140.685 176.799 142.218 176.799 143.774C176.799 145.588 175.261 146.883 173.721 146.883Z'
        fill='#D6DCE8'
      />
      <path
        d='M143.958 85.9792L120.609 85.7197C118.812 85.7197 117.529 84.1648 117.529 82.6098C117.529 80.8172 119.069 79.5215 120.609 79.5215L143.958 79.7804C145.753 79.7804 147.035 81.3358 147.035 82.8692C147.293 84.6834 145.753 85.9792 143.958 85.9792Z'
        fill='#AAB2C5'
      />
      <path
        d='M47.995 85.7197H30.8032C29.0085 85.7197 27.7256 84.1648 27.7256 82.6098C27.7256 80.8172 29.0085 79.5215 30.8032 79.5215H47.995C49.7919 79.5215 51.0748 81.0764 51.0748 82.6098C51.0748 84.424 49.7919 85.7197 47.995 85.7197Z'
        fill='#AAB2C5'
      />
      <path
        d='M114.706 106.366L89.5622 106.107C87.7653 106.107 86.4824 104.552 86.4824 102.997C86.4824 101.204 88.0223 99.9082 89.5622 99.9082L114.706 100.168C116.503 100.168 117.786 101.701 117.786 103.256C118.043 104.811 116.503 106.366 114.706 106.366Z'
        fill='#D6DCE8'
      />
      <path
        d='M192.708 106.863L128.82 106.107C127.023 106.107 125.74 104.552 125.74 102.997C125.74 101.204 127.28 99.9082 128.82 99.9082L192.708 100.686C194.504 100.686 195.787 102.219 195.787 103.774C195.787 105.329 194.247 106.863 192.708 106.863Z'
        fill='#D6DCE8'
      />
      <path
        d='M72.8841 106.107H30.8032C29.0085 106.107 27.7256 104.552 27.7256 102.997C27.7256 101.204 29.2633 99.9082 30.8032 99.9082H72.8841C74.6788 99.9082 75.9618 101.463 75.9618 102.997C75.9618 104.552 74.6788 106.107 72.8841 106.107Z'
        fill='#EAECF3'
      />
      <path
        d='M147.807 126.495L89.5622 126.235C87.7653 126.235 86.4824 124.68 86.4824 123.125C86.4824 121.333 88.0223 120.037 89.5622 120.037L148.064 120.296C149.859 120.296 151.141 121.851 151.141 123.385C151.141 125.199 149.602 126.495 147.807 126.495Z'
        fill='#AAB2C5'
      />
      <path
        d='M72.8841 126.235H30.8032C29.0085 126.235 27.7256 124.68 27.7256 123.125C27.7256 121.333 29.2633 120.037 30.8032 120.037H72.8841C74.6788 120.037 75.9618 121.592 75.9618 123.125C75.9618 124.68 74.6788 126.235 72.8841 126.235Z'
        fill='#D6DCE8'
      />
      <path
        d='M109.316 146.626L77.2437 146.366C75.4489 146.366 74.166 144.811 74.166 143.256C74.166 141.464 75.7037 140.168 77.2437 140.168L109.316 140.427C111.113 140.427 112.396 141.982 112.396 143.515C112.396 145.329 111.113 146.626 109.316 146.626Z'
        fill='#EAECF3'
      />
      <path
        d='M56.7183 146.366H30.8032C29.0085 146.366 27.7256 144.811 27.7256 143.256C27.7256 141.464 29.2633 140.168 30.8032 140.168H56.7183C58.5152 140.168 59.7981 141.723 59.7981 143.256C60.0551 145.07 58.5152 146.366 56.7183 146.366Z'
        fill='#AAB2C5'
      />
      <path
        d='M148.832 55.0076L30.8054 54.4893C29.0085 54.4893 27.7256 52.9344 27.7256 51.3793C27.7256 49.5867 29.2655 48.291 30.8054 48.291L148.832 48.8093C150.629 48.8093 151.912 50.3642 151.912 51.8977C151.912 53.7119 150.629 55.0076 148.832 55.0076Z'
        fill='#AAB2C5'
      />
      <path
        d='M164.213 22.1808H0V10.8204C0 4.90269 4.87457 0 10.7772 0H222.972C228.872 0 233.747 4.90269 233.747 10.8204V22.1808H197.569H164.213Z'
        fill='#D5DDEA'
      />
      <path
        d='M13.8544 15.2251C15.8392 15.2251 17.4482 13.6055 17.4482 11.5969C17.4482 9.60989 15.8392 7.99023 13.8544 7.99023C11.8717 7.99023 10.2627 9.60989 10.2627 11.5969C10.2627 13.6055 11.8717 15.2251 13.8544 15.2251Z'
        fill='#989FB0'
      />
      <path
        d='M24.1191 15.2251C26.1017 15.2251 27.7107 13.6055 27.7107 11.5969C27.7107 9.60989 26.1017 7.99023 24.1191 7.99023C22.1342 7.99023 20.5273 9.60989 20.5273 11.5969C20.5273 13.6055 22.1342 15.2251 24.1191 15.2251Z'
        fill='#989FB0'
      />
      <path
        d='M34.6386 15.2251C36.6234 15.2251 38.2324 13.6055 38.2324 11.5969C38.2324 9.60989 36.6234 7.99023 34.6386 7.99023C32.6559 7.99023 31.0469 9.60989 31.0469 11.5969C31.0469 13.6055 32.6559 15.2251 34.6386 15.2251Z'
        fill='#989FB0'
      />
      <defs>
        <linearGradient
          id='paint0_linear_14815_87917'
          x1='116.798'
          y1='-3.93077'
          x2='116.798'
          y2='171.636'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#F8FAFC' />
          <stop offset='0.9964' stop-color='#ECF0F5' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WindowIcon;
